import { CheckLocalDev } from 'src/config-global';
import { BrandCode, domainBVR, domainMRR, QA_DOMAIN_SUFFIX } from './brandConfig';

export function checkClaimsForHost(claimedCode: string): boolean {
  // handle special dev hosts, first
  if (CheckLocalDev()) {
    return true;
  }

  const actualHostname = window.location.hostname;

  // If the user's host exactly matches our defined brand URLs, validate against that
  if (actualHostname === domainBVR || actualHostname === domainMRR) {
    switch (claimedCode) {
      case BrandCode.BVR:
        return actualHostname === domainBVR;
      case BrandCode.MRR:
        return actualHostname === domainMRR;
      default:
        return false;
    }
  }

  // For development environments (including *.guest-portal-v2.pages.dev),
  // allow any valid brand claims since brand selection is handled by cookies
  if (actualHostname.endsWith(QA_DOMAIN_SUFFIX) ||
      actualHostname.includes('localhost') ||
      actualHostname.includes('127.0.0.1')) {
    return claimedCode === BrandCode.BVR || claimedCode === BrandCode.MRR;
  }

  // For unknown/unsupported hosts in production, reject all claims for security
  console.warn(`Unknown hostname ${actualHostname} - rejecting claims validation`);
  return false;
}
